<template>
  <div class="r-ph-16 r-pv-16">
    <!-- Yıl/Ay + Soru Çeşidi + Branş + Kitap Türü + Kitap + Dinamik property filtreleri için ortak FilterBar -->
    <filter-bar
      ref="filterBarRef"
      :show-first-row="true"
      :show-filter-button="false"
      :show-dynamic-properties="true"
      :is-loading="isLoading"
      @property-change="onDynamicPropertyChange"
    >
      <template #first-row>
        <div style="margin-right: auto;">
          <r-btn
            color="blue"
            variant="contained"
            class="r-mr-16"
            @click="$router.push('/referanslar/video-referanslar')"
          >
            Video Referanslar
          </r-btn>
        </div>

        <r-select
          v-model="selectedYearMonth"
          label="Yıl / Ay"
          :data="yearMonthOptions"
          txt="txt"
          val="val"
          width="18%"
          @change="onYearMonthChange"
        />
        <r-select
          v-model="questPart"
          label="Soru Çeşidi"
          :data="questPartOptions"
          txt="txt"
          val="val"
          width="18%"
          @change="onQuestPartChange"
        />
        <r-select
          v-model="branchId"
          label="Branş"
          :data="branchOptions"
          txt="title"
          val="id"
          width="22%"
          style="color: rgb(17, 17, 17)"
          @change="onBranchChange"
        />
        <r-select
          v-model="subCategoryId"
          label="Alt Kategori"
          :data="subCategoryOptions"
          txt="title"
          val="id"
          width="22%"
          style="color: rgb(17, 17, 17)"
          :disabled="!branchId"
          @change="onSubCategoryChange"
        />
      </template>

      <template #actions>
        <r-select
          v-model="noteCategoryId"
          label="Kitap Türü"
          :data="noteCategoryOptions"
          txt="title"
          val="id"
          width="20%"
          @change="onNoteCategoryChange"
          style="color: rgb(17, 17, 17)"
        />
        <r-select
          label="Kitap"
          :data="noteOptions"
          txt="name"
          val="id"
          :selectable="true"
          v-model:selected="noteIds"
          width="24%"
          style="color: rgb(17, 17, 17)"
        />

        <r-btn
          bgcolor="#1e88e5"
          class="r-ml-8"
          @click="reloadByWorkFolder"
          :disabled="isLoading"
        >
          Filtre
        </r-btn>
        <r-btn
          bgcolor="#ff9800"
          class="r-ml-8"
          @click="clearDynamicFilters"
          :disabled="isLoading"
        >
          Dinamik Filtreyi Temizle
        </r-btn>
      </template>
    </filter-bar>

    <div class="reference-list-scroll-wrapper" v-if="loaded">
      <r-data-list
        class="reference-list-table"
        :headdata="headdata"
        :listdata="filteredList"
        :opt="opts"
        :searchfilter="searchfilter"
        :inner-min-width="1800"
        v-model:qu="q"
      >
      <template v-slot:titleextrabuttons>
        <r-select
          v-if="
            store.state.usertype === 2 &&
              store.state.supers.indexOf(store.state.userrole) >= 0
          "
          v-model="store.state.selectedcatid"
          label="Kategoriler"
          :data="catList.data"
          txt="title"
          val="id"
          width="25%"
          @change="GetCategoryQuestions"
          style="color: rgb(17, 17, 17)"
        >
          <template v-slot:itemtxt="{ data }">
            {{ data.id + "_" + data.title }}
          </template>
        </r-select>
        <r-select
          v-model="exportContentType"
          label="Çıktı içeriği"
          :data="exportContentTypeOptions"
          txt="txt"
          val="val"
          width="18%"
          style="color: rgb(17, 17, 17)"
        />
        <r-btn
          bgcolor="#c62828"
          class="r-ml-8"
          :disabled="!canExport"
          @click="createExportPdf"
        >
          PDF oluştur
        </r-btn>
        <r-btn
          bgcolor="#1565c0"
          class="r-ml-8"
          :disabled="!canExport"
          @click="createExportPpt"
        >
          PPT oluştur
        </r-btn>
        <r-select
          v-model="selectedreference"
          label="Referans Durumu"
          :data="referenceSelect"
          txt="txt"
          val="val"
          width="20%"
        />
        <r-input v-model="qs" label="Soruya Git" width="15%" />
        <button
          class="excel-export-btn"
          @click="exportToExcel"
          title="Excel'e Aktar"
          :disabled="!filteredList || filteredList.length === 0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          <span>Excel</span>
        </button>
      </template>
      <template v-slot:rowextrabtn="{ datarow }">
        <r-btn @click="editReferences(datarow)"
          >Referans Ekle<br />/ Düzenle</r-btn
        >
      </template>
      <!-- 11. kolon: Referans Var mı? -->
      <template v-slot:col11="{ datarow }">
        <span
          class="r-check-ok small"
          v-if="datarow.isReferenced === true"
        ></span>
        <span class="r-check-no small" v-else></span>
      </template>
      <!-- 12. kolon: Video referansı var mı? -->
      <template v-slot:col12="{ datarow }">
        <span
          class="r-check-ok small"
          v-if="datarow.hasVideoReference === true"
        ></span>
        <span class="r-check-no small" v-else></span>
      </template>
      <!-- 14. kolon: Sorunun etiketleri (checkbox etiketleri) -->
      <template v-slot:col14="{ datarow }">
        <span
          class="r-data-list-col-content"
          v-if="datarow.tagLabels && datarow.tagLabels.length"
        >
          <template v-for="(label, idx) in datarow.tagLabels || []" :key="idx">
            <span class="r-tag-check">✓ {{ label }}</span>
            <span v-if="idx < datarow.tagLabels.length - 1"> </span>
          </template>
        </span>
        <span v-else>—</span>
      </template>
      </r-data-list>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, ref, computed } from "vue";
import { useStore } from "vuex";
import router from "@/router";
import { trToUpper } from "@/mix/global";
import FilterBar from "@/components/FilterBar/FilterBar.vue";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import PptxGenJS from "pptxgenjs";
import * as XLSX from "xlsx";

export default {
  components: {
    FilterBar
  },
  setup() {
    const store = useStore();
    const listData = ref({});
    const loaded = ref(false);
    const isLoading = ref(false);
    const q = ref("");
    const qs = ref("");
    const catList = ref({});
    const selectedreference = ref(null);
    const referenceSelect = ref([
      { txt: "Tümü", val: null },
      { txt: "Referanslı", val: "ref-yes" },
      { txt: "Referanssız", val: "ref-no" },
      { txt: "Video referanslı", val: "video-yes" },
      { txt: "Video referanssız", val: "video-no" }
    ]);
    const exportContentType = ref(null);
    const exportContentTypeOptions = ref([
      { txt: "Seçiniz", val: null },
      { txt: "Orijinal soru", val: "original" },
      { txt: "Soru kökü ve çözümü", val: "stem_solution" },
      { txt: "Organik soru", val: "organic" }
    ]);
    const isExporting = ref(false);
    const stripHtml = html => {
      if (!html) return "";
      const div = document.createElement("div");
      div.innerHTML = html;
      return (div.textContent || div.innerText || "").trim();
    };
    const getAnswerLetter = row => {
      if (!row || row.answer == null) return "";
      return String(row.answer).trim().toUpperCase();
    };
    const getAnswerTextFromChoices = row => {
      if (!row || !row.choiceList || !row.choiceList.length) return "";
      const letter = getAnswerLetter(row);
      if (!letter) return "";
      const letters =
        (store.state.choices && store.state.choices.length
          ? store.state.choices
          : ["A", "B", "C", "D", "E"]
        ).map(x => String(x).toUpperCase());
      const idx = letters.findIndex(x => x === letter);
      if (idx < 0 || !row.choiceList[idx]) return "";
      return stripHtml(String(row.choiceList[idx]));
    };
    const nl = "\n";
    /** Metin parçalarını döndürür (PDF vb. için join(nl) kullanılır). */
    const getQuestionTextParts = (row, type) => {
      if (type === "original") {
        const parts = [];
        if (row.isCase && row.case) parts.push("Vaka: " + stripHtml(row.case));
        if (row.detail) parts.push("Soru: " + stripHtml(row.detail));
        if (row.choiceList && row.choiceList.length) {
          const letters = ["A", "B", "C", "D", "E"];
          row.choiceList.forEach((c, i) => {
            if (c && stripHtml(String(c)))
              parts.push(letters[i] + ") " + stripHtml(String(c)));
          });
        }
        if (row.answer) {
          const letter = getAnswerLetter(row);
          const ansText = getAnswerTextFromChoices(row);
          let line = "Doğru Cevap: " + letter;
          if (ansText) line += ") " + ansText;
          parts.push(line);
        }
        return parts;
      }
      if (type === "stem_solution") {
        const parts = [];
        if (row.description) parts.push(stripHtml(row.description));
        else {
          if (row.detailModifield) parts.push(stripHtml(row.detailModifield));
          if (row.answer) {
            const letter = getAnswerLetter(row);
            const ansText = getAnswerTextFromChoices(row);
            let line = "Cevap: " + letter;
            if (ansText) line += ") " + ansText;
            parts.push(line);
          }
        }
        return parts.length ? parts : ["—"];
      }
      if (type === "organic") {
        const parts = [];
        if (row.myOriginalCase)
          parts.push("Vaka: " + stripHtml(row.myOriginalCase));
        if (row.myOriginalDetail)
          parts.push("Soru: " + stripHtml(row.myOriginalDetail));
        const opts = [
          row.myOriginalA,
          row.myOriginalB,
          row.myOriginalC,
          row.myOriginalD,
          row.myOriginalE
        ];
        const letters = ["A", "B", "C", "D", "E"];
        opts.forEach((c, i) => {
          if (c && stripHtml(String(c)))
            parts.push(letters[i] + ") " + stripHtml(String(c)));
        });
        if (row.myOriginalAnswer)
          parts.push("Doğru Cevap: " + row.myOriginalAnswer);
        return parts.length ? parts : ["—"];
      }
      return ["—"];
    };
    const getQuestionTextForExport = (row, type) => {
      return getQuestionTextParts(row, type).join(nl);
    };
    /** PPT için: her satır ayrı text run + breakLine ile; farklı görüntüleyicilerde satır atlaması garanti. */
    const getQuestionTextRunsForPpt = (row, type) => {
      const parts = getQuestionTextParts(row, type);
      return parts.map((text, i) => ({
        text,
        options: {
          breakLine: i < parts.length - 1
        }
      }));
    };
    const getExportList = val => {
      const list = filteredList.value;
      if (val === "stem_solution") {
        return list.filter(
          row => row.isReferenced === true || row.hasVideoReference === true
        );
      }
      return list;
    };
    const canExport = computed(() => {
      const sel = exportContentType.value;
      const val = sel && typeof sel === "object" ? sel.val : sel;
      if (val == null || isExporting.value) return false;
      const list = getExportList(val);
      return list.length > 0;
    });
    const createExportPdf = async () => {
      if (isExporting.value) return;
      const val =
        exportContentType.value && typeof exportContentType.value === "object"
          ? exportContentType.value.val
          : exportContentType.value;
      const exportList = val != null ? getExportList(val) : [];
      if (val == null || !exportList.length) return;
      isExporting.value = true;
      try {
        const doc = new jsPDF("l", "mm", "a5");
        const pageW = 210;
        const pageH = 148;
        const padding = 15;
        const branchForFileName =
          exportList[0] && exportList[0].categoryName
            ? String(exportList[0].categoryName)
                .replace(/[\s/\\:*?"<>|]+/g, "_")
                .slice(0, 40)
            : "";
        for (let i = 0; i < exportList.length; i++) {
          const row = exportList[i];
          const header = `Soru ${row.examNumber || i + 1}`;
          const body = getQuestionTextForExport(row, val);
          const allText = (header + "\n\n" + (body || "")).trim();
          const el = document.createElement("div");
          el.style.cssText = [
            "position:fixed;left:-9999px;top:0;",
            "width:" + pageW + "mm;height:" + pageH + "mm;",
            "padding:" + padding + "mm;box-sizing:border-box;",
            "background:#fff;color:#000;",
            "font-family:Arial,Helvetica,'Segoe UI',sans-serif;font-size:11pt;line-height:1.4;",
            "white-space:pre-wrap;word-wrap:break-word;overflow:hidden;",
            "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;text-align:left;"
          ].join("");
          el.textContent = allText;
          document.body.appendChild(el);
          const canvas = await html2canvas(el, {
            scale: 2,
            backgroundColor: "#ffffff",
            useCORS: true,
            logging: false
          });
          document.body.removeChild(el);
          if (i > 0) doc.addPage();
          const imgData = canvas.toDataURL("image/png");
          doc.addImage(imgData, "PNG", 0, 0, pageW, pageH);
        }
        const safeName = [
          workYear.value || "yil",
          workMonth.value || "ay",
          branchForFileName,
          "sorular.pdf"
        ]
          .filter(Boolean)
          .join("_")
          .replace(/_+/g, "_");
        doc.save(safeName);
      } finally {
        isExporting.value = false;
      }
    };
    const createExportPpt = async () => {
      if (isExporting.value) return;
      const val =
        exportContentType.value && typeof exportContentType.value === "object"
          ? exportContentType.value.val
          : exportContentType.value;
      const exportList = val != null ? getExportList(val) : [];
      if (val == null || !exportList.length) return;
      isExporting.value = true;
      try {
        const pptx = new PptxGenJS();
        pptx.defineLayout({ name: "A4", width: 10, height: 7.5 });
        pptx.layout = "A4";
        const branchForFileNamePpt =
          exportList[0] && exportList[0].categoryName
            ? String(exportList[0].categoryName)
                .replace(/[\s/\\:*?"<>|]+/g, "_")
                .slice(0, 40)
            : "";
        for (let i = 0; i < exportList.length; i++) {
          const row = exportList[i];
          const header = `Soru ${row.examNumber || i + 1}`;
          const bodyRuns = getQuestionTextRunsForPpt(row, val);
          const slide = pptx.addSlide();
          slide.addText(header, {
            x: 0.5,
            y: 0.3,
            w: 9,
            h: 0.6,
            fontSize: 18,
            bold: true
          });
          slide.addText(bodyRuns, {
            x: 0.5,
            y: 1,
            w: 9,
            h: 5.5,
            fontSize: 14,
            valign: "top",
            paraSpaceBefore: 6,
            paraSpaceAfter: 4
          });
        }
        const safeName = [
          workYear.value || "yil",
          workMonth.value || "ay",
          branchForFileNamePpt,
          "sorular.pptx"
        ]
          .filter(Boolean)
          .join("_")
          .replace(/_+/g, "_");
        await pptx.writeFile({ fileName: safeName });
      } finally {
        isExporting.value = false;
      }
    };
    const selectfilter = v => {
      let sel = selectedreference.value;

      // r-select bazı durumlarda doğrudan value'yu, bazı durumlarda option objesini döndürebilir
      if (sel && typeof sel === "object") {
        if ("val" in sel) sel = sel.val;
        else if ("value" in sel) sel = sel.value;
      }
      if (sel === null) {
        return true;
      }

      if (sel === "ref-yes") {
        return v.isReferenced === true;
      }
      if (sel === "ref-no") {
        return v.isReferenced === false;
      }
      if (sel === "video-yes") {
        return v.hasVideoReference === true;
      }
      if (sel === "video-no") {
        return v.hasVideoReference === false;
      }

      return true;
    };
    const goquestionfilter = v => {
      return trToUpper(v.examNumber).includes(trToUpper(qs.value));
    };

    const searchfilter = v => {
      const qVal = trToUpper(q.value || "");
      if (!qVal) return true;
      const tagStr = Array.isArray(v.tagLabels) ? v.tagLabels.join(" ") : "";
      return (
        (v.description && trToUpper(v.description).includes(qVal)) ||
        (v.detail && trToUpper(v.detail).includes(qVal)) ||
        (v.case && trToUpper(v.case).includes(qVal)) ||
        (v.number != null && trToUpper(String(v.number)).includes(qVal)) ||
        (v.examNumber != null &&
          trToUpper(String(v.examNumber)).includes(qVal)) ||
        (v.choiceList &&
          trToUpper(v.choiceList.join?.() || "").includes(qVal)) ||
        (v.difficultyLevelDescription &&
          trToUpper(v.difficultyLevelDescription).includes(qVal)) ||
        (v.referenceBranchName &&
          trToUpper(v.referenceBranchName).includes(qVal)) ||
        (tagStr && trToUpper(tagStr).includes(qVal))
      );
    };
    const listArray = computed(() => {
      const raw = listData.value?.data ?? listData.value?.Data;
      return Array.isArray(raw) ? raw : [];
    });
    const filteredList = computed(() => {
      const arr = listArray.value.slice();
      if (arr.length) {
        arr.sort(
          (a, b) =>
            (parseInt(a.examNumber, 10) || 0) -
            (parseInt(b.examNumber, 10) || 0)
        );
      }
      return arr.filter(goquestionfilter).filter(selectfilter);
    });
    const headdata = computed(() => {
      return [
        {
          title: "Sınav Soru No",
          style: { width: "6%", justifyContent: "center" },
          key: "examNumber"
        },
        {
          title: "Branş",
          style: { width: "8%" },
          key: "categoryName"
        },
        {
          title: "Alt Kategori (B0 Başlıklar)",
          style: { width: "10%" },
          key: "subCategoryName"
        },
        {
          title: "Vaka",
          style: { width: "12%" },
          key: "case",
          cval: v => (v.isCase && v.case ? v.case : ""),
          html: true
        },
        {
          title: "Soru (orijinal)",
          style: { width: "12%" },
          key: "detail",
          html: true
        },
        {
          title: "Şıklar (Doğru Cevap şıkların altında)",
          style: { width: "14%" },
          html: true,
          cval: v => {
            if (!v.choiceList || !v.choiceList.length) return "";
            const hasContent = d => d != null && String(d).trim() !== "";
            const parts = [];
            (v.choiceList || []).forEach((d, i) => {
              if (!hasContent(d)) return;
              const letter =
                (store.state.choices && store.state.choices[i]) || "ABCDE"[i];
              if (d && d.startsWith && d.startsWith("<p>")) {
                parts.push(
                  `${d.slice(0, 3)}<strong>${letter}) </strong>${d.slice(3)}`
                );
              } else {
                parts.push("<strong>" + letter + ") </strong>" + (d || ""));
              }
            });
            if (parts.length === 0) return "";
            let str = parts.join("<br>");
            if (v.answer)
              str +=
                "<br><strong>Doğru Cevap " +
                (v.answer || "").toUpperCase() +
                "</strong>";
            return str;
          }
        },
        {
          title: "Soru Kökü ve Cevabı",
          style: { width: "12%" },
          key: "detailModifield",
          cval: v => v.detailModifield || v.DetailModifield || "",
          html: true
        },
        {
          title: "Organik Vaka",
          style: { width: "12%" },
          key: "myOriginalCase",
          html: true
        },
        {
          title: "Organik soru",
          style: { width: "12%" },
          key: "myOriginalDetail",
          html: true
        },
        {
          title: "Organik soru şıklar (Doğru Cevap şıkların altında)",
          style: { width: "14%" },
          html: true,
          cval: v => {
            const opts = [
              v.myOriginalA,
              v.myOriginalB,
              v.myOriginalC,
              v.myOriginalD,
              v.myOriginalE
            ];
            const letters = ["A", "B", "C", "D", "E"];
            const hasContent = d => d != null && String(d).trim() !== "";
            const parts = [];
            (opts || []).forEach((d, i) => {
              if (!hasContent(d)) return;
              const letter =
                (store.state.choices && store.state.choices[i]) || letters[i];
              if (d && d.startsWith && d.startsWith("<p>")) {
                parts.push(
                  d.slice(0, 3) +
                    "<strong>" +
                    letter +
                    ") </strong>" +
                    d.slice(3)
                );
              } else {
                parts.push("<strong>" + letter + ") </strong>" + (d || ""));
              }
            });
            if (parts.length === 0) return "";
            let str = parts.join("<br>");
            if (v.myOriginalAnswer)
              str +=
                "<br><strong>Doğru Cevap " +
                (v.myOriginalAnswer || "").toUpperCase() +
                "</strong>";
            return str;
          }
        },
        {
          title: "Referans Var mı?",
          style: { width: "8%", justifyContent: "center" },
          key: "isReferenced"
        },
        {
          title: "Video referansı var mı?",
          style: { width: "10%", justifyContent: "center" },
          key: "hasVideoReference"
        },
        {
          title: "Sorunun zorluk seviyesi",
          style: { width: "10%" },
          key: "difficultyLevelDescription"
        },
        {
          title: "Sorunun etiketleri",
          style: { width: "12%" },
          key: "tagLabels"
        },
        {
          title: "Hangi branş referans verdi",
          style: { width: "10%" },
          key: "referenceBranchName"
        }
      ];
    });
    const opts = ref({
      title: "Sorular",
      buttons: {
        style: { width: "10%", minWidth: "120px" }
      }
    });

    // Yıl-Ay filtresi için state ve yardımcılar
    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);
    const workYear = ref("");
    const workMonth = ref("");
    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });

    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "settings/getmonthyear"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };

    const reloadByWorkFolder = async () => {
      if (store.state.usertype === 0 || store.state.usertype === 1) {
        listData.value = await getList();
      } else if (store.state.usertype === 2) {
        listData.value = await getQuestionList(store.state.selectedcatid);
      }
    };

    const onYearMonthChange = async e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        workYear.value = year;
        workMonth.value = month;
        isLoading.value = true;
        try {
          await reloadByWorkFolder();
        } finally {
          isLoading.value = false;
        }
      }
    };

    // Dinamik property ve ortak soru filtreleri için state
    const dynamicPropertyFilters = ref({});
    const filterBarRef = ref(null);

    const questPart = ref(null);
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const branchId = ref(null);
    const branchList = ref({ data: [] });
    const subCategoryId = ref(null);
    const subCategoryList = ref({ data: [] });

    const notesCatsList = ref({ data: [] });
    const noteCategoryId = ref(null);
    const noteList = ref({ data: [] });
    const noteIds = ref([]);

    // Seçim listelerine "Hepsi" opsiyonu ekleyen computed'lar
    const questPartOptions = computed(() => {
      const base = questParts.value || [];
      return [{ txt: "Hepsi", val: null }, ...base];
    });

    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Hepsi", id: null }, ...arr];
    });

    const subCategoryOptions = computed(() => {
      const arr =
        subCategoryList.value && Array.isArray(subCategoryList.value.data)
          ? subCategoryList.value.data
          : [];
      return [{ title: "Hepsi", id: null }, ...arr];
    });

    const noteCategoryOptions = computed(() => {
      const arr =
        notesCatsList.value && Array.isArray(notesCatsList.value.data)
          ? notesCatsList.value.data
          : [];
      return [{ title: "Hepsi", id: null }, ...arr];
    });

    const noteOptions = computed(() => {
      const src = noteList.value || {};
      const arr = Array.isArray(src.data)
        ? src.data
        : Array.isArray(src.Data)
        ? src.Data
        : [];
      return [{ name: "Hepsi", id: null }, ...arr];
    });

    const onDynamicPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      if (!payload || payload.propertyDefinitionId == null) return;
      dynamicPropertyFilters.value = {
        ...dynamicPropertyFilters.value,
        [payload.propertyDefinitionId]: payload.selectedValues || []
      };
    };

    const clearDynamicFilters = async () => {
      dynamicPropertyFilters.value = {};
      // FilterBar içindeki dinamik checkbox'ları da sıfırla
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
      isLoading.value = true;
      try {
        await reloadByWorkFolder();
      } finally {
        isLoading.value = false;
      }
    };

    const getList = async () => {
      // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
      const dynamicValues = dynamicPropertyFilters.value || {};
      const allValueIds = Object.values(dynamicValues)
        .reduce((acc, arr) => {
          if (Array.isArray(arr)) {
            return acc.concat(arr);
          }
          return acc;
        }, [])
        .filter((v, idx, arr) => arr.indexOf(v) === idx);

      // Backend parametreleri (klavuz kuralları):
      // categoryid : Branş (B0 = Question.CategoryId)
      // subcatid   : Alt kategori (B1 = Question.SubCategoryId); 0 = Hepsi → üst categoryId ile filtre
      // Soru çeşidi (questPart) sadece UI'da branş listesini yükler, API'ye gönderilmez.
      const params = {
        categoryid: branchId.value || 0,
        subcatid: subCategoryId.value || 0,
        page: 1,
        size: 300,
        order: 1,
        workmonth: workMonth.value,
        workyear: workYear.value
      };

      // Kitap türü / kitaplar: noteIds varsa kitaplar, yoksa noteCategoryId (kitap türü)
      const uniqueNoteIds = Array.from(new Set(noteIds.value || []));
      if (uniqueNoteIds.length > 0 && uniqueNoteIds[0] != null) {
        params.noteIds = uniqueNoteIds.join(",");
      } else if (noteCategoryId.value) {
        params.noteCategoryId = noteCategoryId.value;
      }

      if (allValueIds.length > 0) {
        params.dynamicPropertyValueIds = allValueIds.join(",");
      }

      let list = await store.dispatch("getDatas", {
        api: "questions/GetQuestionsByCategory",
        params
      });
      return list;
    };
    const getQuestionList = async id => {
      // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
      const dynamicValues = dynamicPropertyFilters.value || {};
      const allValueIds = Object.values(dynamicValues)
        .reduce((acc, arr) => {
          if (Array.isArray(arr)) {
            return acc.concat(arr);
          }
          return acc;
        }, [])
        .filter((v, idx, arr) => arr.indexOf(v) === idx);

      // Backend parametreleri: categoryid = tıklanan branş (id), subcatid = alt kategori (B1)
      const params = {
        categoryid: id,
        subcatid: subCategoryId.value || 0,
        page: 1,
        size: 300,
        order: 1,
        workmonth: workMonth.value,
        workyear: workYear.value
      };

      const uniqueNoteIds = Array.from(new Set(noteIds.value || []));
      if (uniqueNoteIds.length > 0 && uniqueNoteIds[0] != null) {
        params.noteIds = uniqueNoteIds.join(",");
      } else if (noteCategoryId.value) {
        params.noteCategoryId = noteCategoryId.value;
      }

      if (allValueIds.length > 0) {
        params.dynamicPropertyValueIds = allValueIds.join(",");
      }

      let list = await store.dispatch("getDatas", {
        api: "questions/GetQuestionsByCategory",
        params
      });
      return list;
    };
    const GetCategoryQuestions = async d => {
      listData.value = await getQuestionList(d.id);
    };
    const getCatList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: {
          pid: 0
        }
      });

      return list;
    };
    const editReferences = async d => {
      router.push("/referanslar/duzenle/" + d.id);
    };
    const getNoteCatsList = async () => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return res;
    };

    const getNotesByCategory = async (categoryId, notCategoryId) => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return res;
    };

    const onQuestPartChange = async e => {
      if (e == null) return;
      // RSelect: change event bazen item objesi, bazen primitive gönderebilir
      const qpVal = typeof e === "object" ? e.val : e;
      questPart.value = qpVal !== undefined ? qpVal : null;

      // Tüm kategorileri al (pid=0); Hepsi seçiliyse tümünü, değilse parentId'ye göre filtrele
      const result = await getCatList();
      if (result && result.data && Array.isArray(result.data)) {
        const filteredData =
          questPart.value === null
            ? result.data
            : result.data.filter(item => {
                const parentId =
                  item.parentId !== undefined ? item.parentId : item.ParentId;
                if (questPart.value === 1) return parentId === 1;
                if (questPart.value === 2) return parentId === 2;
                return false;
              });
        branchList.value = { data: filteredData };
        // Soru çeşidi seçilince Branş otomatik ilk elemana kaymasın; Hepsi (null) kalsın
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };

        // Branş değiştiği için kitap seçimlerini de sıfırla (kullanıcı manuel seçsin)
        noteIds.value = [];
        noteList.value = { data: [] };
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
        noteList.value = { data: [] };
      }

      // Soru çeşidi değiştiğinde filtreyi uygula
      if (store.state.usertype === 2) {
        isLoading.value = true;
        try {
          await reloadByWorkFolder();
        } finally {
          isLoading.value = false;
        }
      }
    };

    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      branchId.value = e.id;

      // Seçilen branşın alt kategorilerini getir
      if (e.id) {
        const result = await store.dispatch("getDatas", {
          api: "categories/getsubcategories",
          params: { pid: e.id }
        });
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
          subCategoryId.value = null; // Seçimi kullanıcıya bırak
        } else {
          subCategoryList.value = { data: [] };
          subCategoryId.value = null;
        }
      } else {
        subCategoryList.value = { data: [] };
        subCategoryId.value = null;
      }

      // Branş değiştiğinde kitap listesini güncelle
      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
        } else {
          noteList.value = { data: [] };
        }
      } else {
        noteList.value = { data: [] };
      }

      // Branş değiştiğinde filtreyi uygula
      if (store.state.usertype === 2) {
        isLoading.value = true;
        try {
          await reloadByWorkFolder();
        } finally {
          isLoading.value = false;
        }
      }
    };

    const onSubCategoryChange = async () => {
      // Alt kategori değiştiğinde filtreyi uygula
      if (store.state.usertype === 2) {
        isLoading.value = true;
        try {
          await reloadByWorkFolder();
        } finally {
          isLoading.value = false;
        }
      }
    };

    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;
      // Kitap türü değiştiğinde noteIds'i sıfırla (kullanıcı manuel seçsin)
      // Backend'de öncelik sırası: noteIds > noteCategoryId
      // noteIds dolu olduğunda noteCategoryId filtresi çalışmaz
      noteIds.value = [];

      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
          // noteIds'i boş bırak - kullanıcı manuel olarak seçsin
          // Böylece backend'de noteCategoryId filtresi çalışır
        } else {
          noteList.value = { data: [] };
        }
      } else {
        noteList.value = { data: [] };
      }
      // Kitap türü değiştiğinde filtreyi uygula
      if (store.state.usertype === 2) {
        isLoading.value = true;
        try {
          await reloadByWorkFolder();
        } finally {
          isLoading.value = false;
        }
      }
    };

    const exportToExcel = () => {
      const rows = filteredList.value || [];
      if (!rows.length) {
        alert("Export edilecek veri bulunamadı.");
        return;
      }

      const choicesLetters = store.state.choices || ["A", "B", "C", "D", "E"];

      const excelData = rows.map(row => {
        const vakaText =
          row.isCase && row.case ? stripHtml(String(row.case)) : "";

        let choicesText = "";
        if (row.choiceList && Array.isArray(row.choiceList)) {
          const parts = [];
          row.choiceList.forEach((choice, idx) => {
            if (choice == null || String(choice).trim() === "") return;
            const letter = choicesLetters[idx] || "ABCDE"[idx] || "";
            parts.push(`${letter}) ${stripHtml(String(choice))}`);
          });
          if (row.answer) {
            parts.push(`Doğru Cevap: ${(row.answer || "").toUpperCase()}`);
          }
          choicesText = parts.join("\n");
        }

        let stemAndAnswer = "";
        if (row.description) {
          stemAndAnswer = stripHtml(String(row.description));
        } else {
          const root = row.detailModifield
            ? stripHtml(String(row.detailModifield))
            : "";
          const ans = row.answer ? ` Cevap: ${row.answer}` : "";
          stemAndAnswer = `${root}${ans}`.trim();
        }

        const organicOpts = [
          row.myOriginalA,
          row.myOriginalB,
          row.myOriginalC,
          row.myOriginalD,
          row.myOriginalE
        ];
        const organicParts = [];
        organicOpts.forEach((opt, idx) => {
          if (opt == null || String(opt).trim() === "") return;
          const letter = choicesLetters[idx] || ["A", "B", "C", "D", "E"][idx];
          organicParts.push(`${letter}) ${stripHtml(String(opt))}`);
        });
        if (row.myOriginalAnswer) {
          organicParts.push(
            `Doğru Cevap: ${(row.myOriginalAnswer || "").toUpperCase()}`
          );
        }
        const organicChoicesText = organicParts.join("\n");

        const tagsText = Array.isArray(row.tagLabels)
          ? row.tagLabels.join(", ")
          : "";

        return {
          "Sınav Soru No": row.examNumber,
          Branş: row.categoryName || "",
          "Alt Kategori (B0 Başlıklar)": row.subCategoryName || "",
          Vaka: vakaText,
          "Soru (orijinal)": stripHtml(String(row.detail || "")),
          "Şıklar (Doğru Cevap şıkların altında)": choicesText,
          "Soru Kökü ve Cevabı": stemAndAnswer,
          "Organik Vaka": stripHtml(String(row.myOriginalCase || "")),
          "Organik soru": stripHtml(String(row.myOriginalDetail || "")),
          "Organik soru şıklar (Doğru Cevap şıkların altında)":
            organicChoicesText,
          "Organik Cevap": row.myOriginalAnswer || "",
          "Referans Var mı?": row.isReferenced ? "Evet" : "Hayır",
          "Video referansı var mı?": row.hasVideoReference ? "Evet" : "Hayır",
          "Sorunun zorluk seviyesi":
            row.difficultyLevelDescription || "",
          "Sorunun etiketleri": tagsText,
          "Hangi branş referans verdi": row.referenceBranchName || ""
        };
      });

      const ws = XLSX.utils.json_to_sheet(excelData);

      ws["!cols"] = [
        { wch: 12 },
        { wch: 18 },
        { wch: 24 },
        { wch: 24 },
        { wch: 36 },
        { wch: 40 },
        { wch: 36 },
        { wch: 30 },
        { wch: 36 },
        { wch: 40 },
        { wch: 16 },
        { wch: 18 },
        { wch: 22 },
        { wch: 26 },
        { wch: 28 },
        { wch: 26 }
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Referanslar");

      const fileName = `Referanslar_${
        workYear.value || ""
      }${workMonth.value || ""}_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;

      XLSX.writeFile(wb, fileName);
    };

    onBeforeMount(async () => {
      // Yıl-Ay kombinasyonlarını yükle (en güncel dönem varsayılan)
      await loadYearMonths();
      if (yearMonthList.value.length > 0) {
        const current = yearMonthList.value[0];
        selectedYearMonth.value = current;
        const parts = current.split("-");
        if (parts.length === 2) {
          const [year, month] = parts;
          workYear.value = year;
          workMonth.value = month;
        }
      }

      catList.value = await getCatList();

      // Ortak filtreler için başlangıç verilerini yükle (kitap türü + branş)
      const noteCats = await getNoteCatsList();
      notesCatsList.value = noteCats || { data: [] };

      const branchResult = await getCatList();
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        // questPart yoksa (Hepsi) tüm branşlar; varsa aynı filtre
        const filteredData =
          questPart.value == null
            ? branchResult.data
            : branchResult.data.filter(item => {
                const parentId =
                  item.parentId !== undefined ? item.parentId : item.ParentId;
                return parentId === questPart.value;
              });
        branchList.value = { data: filteredData };
        branchId.value = null;
      }

      if (store.state.usertype === 0 || store.state.usertype === 1) {
        listData.value = await getList();
      } else if (store.state.usertype === 2) {
        if (store.state.selectedcatid === null) {
          if (store.state.usercatid !== null)
            store.state.selectedcatid = store.state.usercatid;
          else store.state.selectedcatid = catList.value.data[0].id;

          if (!catList.value.data.some(v => v.id === store.state.selectedcatid))
            store.state.selectedcatid = catList.value.data[0].id;
        }

        listData.value = await getQuestionList(store.state.selectedcatid);
      }
      loaded.value = true;
    });
    return {
      headdata,
      opts,
      editReferences,
      loaded,
      searchfilter,
      q,
      qs,
      isLoading,
      selectedreference,
      referenceSelect,
      exportContentType,
      exportContentTypeOptions,
      canExport,
      createExportPdf,
      createExportPpt,
      filteredList,
      yearMonthList,
      selectedYearMonth,
      yearMonthOptions,
      onYearMonthChange,
      reloadByWorkFolder,
      catList,
      GetCategoryQuestions,
      store,
      // FilterBar ile ilgili state ve fonksiyonlar
      dynamicPropertyFilters,
      filterBarRef,
      questPart,
      questParts,
      questPartOptions,
      branchId,
      branchList,
      branchOptions,
      subCategoryId,
      subCategoryList,
      subCategoryOptions,
      notesCatsList,
      noteCategoryId,
      noteList,
      noteIds,
      noteCategoryOptions,
      noteOptions,
      onDynamicPropertyChange,
      clearDynamicFilters,
      onQuestPartChange,
      onBranchChange,
      onSubCategoryChange,
      onNoteCategoryChange,
      exportToExcel
    };
  }
};
</script>
<style scoped>
.r-tag-check {
  display: inline-block;
  margin-right: 0.35em;
  white-space: nowrap;
}

.excel-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin-left: 8px;
  background-color: #217346;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.excel-export-btn:hover {
  background-color: #1a5c38;
}

.excel-export-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.excel-export-btn svg {
  flex-shrink: 0;
}

/* Liste alanı kendi içinde dikey scroll olsun; böylece sticky header bu container'a göre sabitlenir */
.reference-list-scroll-wrapper {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: visible;
}

.reference-list-table :deep(.r-data-list-header-C) {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: var(--data-list-header-bg-color, #f0f0f0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
